import { forwardRef } from 'react';
import { type TamaguiElement, YStack } from 'tamagui';

type Props = {
  children: React.ReactNode;
};

const ListboxOptions = forwardRef<TamaguiElement, Props>(({ children, ...restProps }, ref) => {
  return (
    <YStack
      ref={ref}
      borderWidth={1}
      borderColor="$border"
      mt="$1"
      tag="ul"
      position="absolute"
      width="auto"
      minWidth="100%"
      top="100%"
      zIndex={10}
      maxHeight={250}
      overflow="scroll"
      {...restProps}
    >
      {children}
    </YStack>
  );
});

export default ListboxOptions;
